import React, { useState } from 'react'
import Newlogin from './Newlogin';
import { useDispatch, useSelector } from 'react-redux';
import { clearError, LoginbyGoogle } from '../../redux/reducers/authSlice';
import { useNavigate } from 'react-router-dom';
import {snackbarContext} from '../helpers/Snakbar'
import TrialOtp from './TrialOtp';
import Loader from '../helpers/Loader';


const Loginflow = () => {
    const {error:backendError,loading}=useSelector((state)=>state.auth)
    const [step, setStep] = useState("start");
     const [otpMode, setOtpMode] = useState("normal");
     const dispatch=useDispatch()
       const setStateSnackbarContext=React.useContext(snackbarContext)
       const navigate=useNavigate()

    const handleGoogle=(response)=>{
     dispatch(LoginbyGoogle({credential:response.credential,setStateSnackbarContext,navigate}))
    }

   const handleOtp=(mode = "normal")=>{
           setOtpMode(mode);
            setStep("otp");
    }

    if(backendError){
      setStateSnackbarContext(
        true,
        backendError,
        "warning"
      )
      dispatch(clearError())
    }

    if(loading){
      return <Loader/>
    }
  
  return (
  <>
           {step==="start" && (
            <Newlogin  
              onGoogle={handleGoogle}
              onContinue={handleOtp}
            />
           )}

           {step==="otp" && (
            <TrialOtp  
            onContinue={handleOtp}
              onBack={() => setStep("start")}
              login="true"
               otpMode={otpMode}
              />

           )}
           </>
  )
}

export default Loginflow